"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = exports.Btn = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const Btn = exports.Btn = /*#__PURE__*/(0, _base.default)("button", process.env.NODE_ENV === "production" ? {
  target: "ebr9ex40"
} : {
  target: "ebr9ex40",
  label: "Btn"
})();
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1g8p5l7",
  styles: "background-color:transparent;color:black"
} : {
  name: "xfcu8k-successOutline",
  styles: "background-color:transparent;color:black;label:successOutline;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
const styles = exports.styles = {
  default: theme => /*#__PURE__*/(0, _react.css)("display:flex;align-items:center;justify-content:center;height:38px;padding:0 1.5em;border-radius:19px;background-color:", theme.btnDefault, ";border:1px solid ", theme.btnDefault, ";color:", theme.btnDefaultFontColor, ";text-align:center;line-height:20px;font-size:14px;font-weight:600;cursor:pointer;text-decoration:none;&:focus{text-decoration:underline;background-color:", theme.btnDefaultLighter, ";border-color:", theme.btnDefaultLighter, ";color:", theme.btnHoverTextColor, ";outline:none;}&:hover{background-color:", theme.btnDefaultDarker, ";border-color:", theme.btnDefaultDarker, ";color:", theme.btnHoverTextColor, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:default;")),
  highlighted: process.env.NODE_ENV === "production" ? {
    name: "1qllkub",
    styles: "height:46px;font-size:16px;line-height:22px;border-radius:23px"
  } : {
    name: "lx2bay-highlighted",
    styles: "height:46px;font-size:16px;line-height:22px;border-radius:23px;label:highlighted;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  icon: theme => /*#__PURE__*/(0, _react.css)("display:inline-flex;justify-content:space-between;&>svg>polygon{fill:", theme.btnDefaultFontColor, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:icon;")),
  beforeIcon: process.env.NODE_ENV === "production" ? {
    name: "182kuw3",
    styles: "padding-left:0.75em;&>svg{margin-right:5px;}"
  } : {
    name: "1gn9sdw-beforeIcon",
    styles: "padding-left:0.75em;&>svg{margin-right:5px;};label:beforeIcon;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  afterIcon: process.env.NODE_ENV === "production" ? {
    name: "1sby9l6",
    styles: "padding-right:0.75em;&>svg{margin-left:5px;}"
  } : {
    name: "vx4r34-afterIcon",
    styles: "padding-right:0.75em;&>svg{margin-left:5px;};label:afterIcon;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  outline: theme => /*#__PURE__*/(0, _react.css)("border:2px solid ", theme.btnDefault, ";color:black;background-color:white;&>svg>polygon{fill:black!important;}&:hover,&:focus{&>svg>polygon,&>svg>path{fill:", theme.btnHoverTextColor, "!important;}}&:focus{color:", theme.btnHoverTextColor, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:outline;")),
  success: theme => /*#__PURE__*/(0, _react.css)("background-color:", theme.btnSuccess, ";border-color:", theme.btnSuccess, ";color:black;&:focus{text-decoration:underline;background-color:", theme.btnSuccessLighter, ";border-color:", theme.btnSuccessLighter, ";color:black;}&:hover{background-color:", theme.btnSuccessDarker, ";border-color:", theme.btnSuccessDarker, ";color:black;}" + (process.env.NODE_ENV === "production" ? "" : ";label:success;")),
  danger: theme => /*#__PURE__*/(0, _react.css)("background-color:", theme.btnDanger, ";border-color:", theme.btnDanger, ";color:white;&:focus{text-decoration:underline;background-color:", theme.btnDangerLighter, ";border-color:", theme.btnDangerLighter, ";}&:hover{background-color:", theme.btnDangerDarker, ";border-color:", theme.btnDangerDarker, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:danger;")),
  disabled: theme => /*#__PURE__*/(0, _react.css)("background-color:", theme.btnDisabled, ";border-color:", theme.btnDisabled, ";color:black;&:hover{background-color:", theme.btnDisabled, ";border-color:", theme.btnDisabled, ";color:black;cursor:default;}" + (process.env.NODE_ENV === "production" ? "" : ";label:disabled;")),
  border: color => /*#__PURE__*/(0, _react.css)("border-color:", color, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:border;")),
  loading: theme => /*#__PURE__*/(0, _react.css)("opacity:0.8;cursor:default;&:hover{&>span>div>div{background:", theme.btnDefaultFontColor, ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:loading;")),
  nostyle: process.env.NODE_ENV === "production" ? {
    name: "423zxq",
    styles: "padding:0;outline:none;border:none;background-color:transparent;height:auto;color:black;&:hover,&:focus,&:active{background-color:transparent;border:none;color:black;}&>svg>polygon{fill:black;}"
  } : {
    name: "4mfvfl-nostyle",
    styles: "padding:0;outline:none;border:none;background-color:transparent;height:auto;color:black;&:hover,&:focus,&:active{background-color:transparent;border:none;color:black;}&>svg>polygon{fill:black;};label:nostyle;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  back: theme => /*#__PURE__*/(0, _react.css)("background-color:transparent;color:black;border:2px solid ", theme.btnBackBorder, ";height:32px;padding:0 1.5em;&>span{padding:0 0.5em;}&:focus{border-color:", theme.secondary, ";background-color:transparent;color:black;text-decoration:none;}&:hover,&:active{background-color:", theme.secondary, ";border:2px solid ", theme.btnBackBorder, ";color:", theme.btnHoverTextColor, ";&>svg{fill:", theme.btnHoverTextColor, "!important;}}" + (process.env.NODE_ENV === "production" ? "" : ";label:back;")),
  small: process.env.NODE_ENV === "production" ? {
    name: "db171r",
    styles: "height:30px;padding:0 1.5em"
  } : {
    name: "14e3blf-small",
    styles: "height:30px;padding:0 1.5em;label:small;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  dangerOutline: theme => /*#__PURE__*/(0, _react.css)("background-color:transparent;color:", theme.btnDanger, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:dangerOutline;")),
  successOutline: theme => _ref,
  transparentBg: process.env.NODE_ENV === "production" ? {
    name: "1peqg37",
    styles: "background-color:transparent"
  } : {
    name: "x2hhac-transparentBg",
    styles: "background-color:transparent;label:transparentBg;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  focusable: process.env.NODE_ENV === "production" ? {
    name: "1qjpqms",
    styles: "&:focus-visible{outline:1px dotted #212121;outline:5px auto -webkit-focus-ring-color;}"
  } : {
    name: "jatm0f-focusable",
    styles: "&:focus-visible{outline:1px dotted #212121;outline:5px auto -webkit-focus-ring-color;};label:focusable;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }
};
var _default = exports.default = styles;